// getQuickpayCtaTranslationKey.js
'use strict';
import getTranslationKey from '../resource/getTranslationKey.js';

/**
 * Build the guided-purchase ("quickpay") CTA translation key for a copy base,
 * suffixed by the buyer's completed purchase count. Callers should only build
 * this when the user is a quickpay user, so the suffix stays within the
 * configured range that has translations defined.
 * @param {object} params
 * @param {string} params.base - CTA copy base, e.g. 'unlock_post'.
 * @param {number} params.purchaseCount - completed purchase count.
 * @returns {string} Normalized key, e.g. 'cta_quickpay_unlock_post_2'.
 */
const getQuickpayCtaTranslationKey = ({ base, purchaseCount }) =>
  getTranslationKey({ key: `cta_quickpay_${base}_${purchaseCount}` });

export default getQuickpayCtaTranslationKey;
